import type { MenuProps as AntdMenuProps, MenuRef } from "antd";
import { Menu as AntdMenu } from "antd";
import React from "react";

export interface MenuProps extends AntdMenuProps {}

const Menu = React.forwardRef<MenuRef, MenuProps>((props, ref) => {
  return <AntdMenu ref={ref} {...props} />;
});

Menu.displayName = "Menu";

export default Menu;
